export default "__VITE_ASSET__Fu1p21wq__"